module.exports = __webpack_public_path__ + "img/chrome-store-screen.37c97604.png";